export enum SettingNamesEnum {
  LayoutTypeSorting = 'LayoutTypeSorting',
  PoolTypeSorting = 'PoolTypeSorting',
  FieldConfig = 'FieldConfig',
  FaultFieldsMemoryValues = 'FaultFieldsMemoryValues',
  UseAlternativeReportingApi = 'UseAlternativeReportingApi',
  MaxProjectStructureLevel = 'maxProjectStructureLevel'
}
